export const ACTION_PREFIX = '@eyko/Designer/Ingestion';
